export interface FormulaResponse {
	isValid: boolean;
	message: string;
	result: any;
}